/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { MonthDto } from './monthDto.schema';

export const IReadOnlyListOfMonthDto = zod.array(zod.lazy(() => MonthDto));

export type IReadOnlyListOfMonthDto = zod.input<typeof IReadOnlyListOfMonthDto>;
export type IReadOnlyListOfMonthDtoOutput = zod.output<typeof IReadOnlyListOfMonthDto>;
